/**
 * @ngdoc service
 * @name common.address.service:AddressService
 * @description
 * 
 */
(function() {
    'use strict';

    angular
        .module('itxApp.legacy')
        .service('AddressService', AddressService);

    AddressService.$inject = [
        '$q',
        'ItxErrorMessagesFct',
        'ItxTranslateSvc',
        'CountryService',
        'DUTTI_CONS'
    ];

    function AddressService(
        $q,
        ItxErrorMessagesFct,
        ItxTranslateSvc,
        CountryService,
        DUTTI_CONS
    ) {

        var _this = this;
        
        _this.addressBookCache = {};
        _this.regexZipCode = '';
        _this.IdentDocRegex = '';
        _this.isColombia = CountryService.is(DUTTI_CONS.country.CO);
        _this.pickupFormModel;

        inditex.getXconfiguracionValue('NEWSLETTER_DOUBLE_OPT_IN', function(status, value) {
            if (value === '1') {
                _this.optIn = true;
            }
        });

        inditex.getXConfigParameter('ZIPCODE_REGEXP_VALIDATION', function(value){
            _this.regexZipCode = new RegExp(value.value);
        });

        if (!_this.countryConfigCache) {
            getConfigAddress().then(function (value) {
                _this.countryConfigCache = value;
            });
        }

        var service = {
            getAddressInfo: getAddressInfo,
            getGeocoderSuggestion: getGeocoderSuggestion,
            incompleteSuggestedAddress: incompleteSuggestedAddress,
            prepareAddress: prepareAddress,
            createEmptyAddress: _createEmptyAddress,
            getUserAddresses: getUserAddresses,
            getAddressSubtitle: getAddressSubtitle,
            getAddressTitle: getAddressTitle,
            isRestrictedZipCode: isRestrictedZipCode,
            addOrUpdateAddress: addOrUpdateAddress,
            fillDroppointAddress: fillDroppointAddress,
            getBillingAddress: getBillingAddress,
            getBillingAddressZipCode: getBillingAddressZipCode,
            getBillingAddressIsDocumentMandatory: getBillingAddressIsDocumentMandatory,
            isBillingAddressCompleteForDroppoint: isBillingAddressCompleteForDroppoint,
            save: save,
            getCountryFormParameters: getCountryFormParameters,
            _checkAndCloneAddress: checkAndCloneAddress,
            checkWalletAddress: checkWalletAddress,
            _billingAddressHasBeenCloned: billingAddressHasBeenCloned,
            _fillHiddendFields: fillHiddendFields,
            _getShippingAddressId: getShippingAddressId,
            getFormatAddressQatar: getFormatAddressQatar,
            verifyTaxFieldsBillingAddress: verifyTaxFieldsBillingAddress,
            getCountryInfo: getCountryInfo,
            getConfigAddress: getConfigAddress,
            getBeneficiaryCode: getBeneficiaryCode
            //getIfscCode: getIfscCode
        };

        return service;

        /**
        * @ngdoc method
        * @name getCountryFormParameters
        * @methodOf common.address.service:AddressService 
        * @description
        * Manage address form special fields.
        */
        function getCountryFormParameters(country, parameter){
            var countryFormAddressParameters = {
                AE: {
                    city: false,
                    city_combo: true,
                    zipcode: false,
                    province_dependant: true
                },
                AL: {
                    city: false,
                    city_combo: true,
                    zipcode: false,
                    province_dependant: true,
                    company: false,
                    company_registration: false
                },
                AM: {
                    province: false,
                    province_china: true,
                    district_nocombo: true,
                    zipcode: true,
                    nif: false,
                    personal_nif: true
                },
                AZ: {
                    city: false,
                    province_dependant: true,
                    city_combo: true,
                    district_nocombo: true,
                    zipcode: true,
                    nif: false
                },
                BA: {
                    company: false,
                    company_registration: false,
                    addressLine: true
                },
                BG: {
                    bulgary_company: true,
                    company: false
                },
                BH: {
                    city: false,
                    city_combo: true,
                    zipcode: false,
                    province_dependant: true
                },
                CN: {
                    province_china: true,
                    province: false,
                    city: false,
                    city_combo: true
                },
                CO: {
                    ident_document: true,
                    identdocument_value: true,
                    regimen_fiscal: true,
                    taxcode_id: true,
                    city: false,
                    city_combo: true,
                    province_dependant: true
                },
                CY: {
                    city: false,
                    city_combo: true,
                    company_registration: false,
                    province_dependant: true
                },
                DZ: {
                    company: false,
                    city_combo: true,
                    city: false
                },
                EE: {
                    company_registration: true
                },
                EG: {
                    city: false,
                    city_combo: true,
                    zipcode: false,
                    province_dependant: true,
                    egypt_company: true
                },
                FR: {
                    digicode: true
                },
                GE: {
                    company_registration: false,
                    city: false,
                    city_combo: true,
                    province_dependant: true,
                    company: false,
                    nif: false,
                    personal_nif: true
                },
                HK: {
                    city: false,
                    city_combo: true,
                    company_registration: false,
                    lastname: false
                },
                //Indonesia
                ID: {
                    city_combo: true,
                    city: false,
                    province_dependant: true,
                    company_registration: false,
                    zipcode: true
                },
                IL: {
                    zipcode: false,
                    city: false,
                    city_combo: true,
                    company_registration: false
                },
                // India
                IN: {
                    company: false,
                    municipality: true,
                    ifsccode: true
                },
                IT: {
                    italy_company: true
                },
                JO: {
                    city: false,
                    city_combo: true,
                    province_dependant: true,
                    zipcode: false
                },
                KZ: {
                    city_combo: true,
                    city: false,
                    province_dependant: true,
                    company_registration: false,
                    company: false
                },
                KR: {
                    lastname: false,
                    vatin: false
                },
                KW: {
                    city: false,
                    city_combo: true,
                    zipcode: false,
                    province_dependant: false
                },
                LB: {
                    city: false,
                    city_combo: true,
                    province_dependant: true,
                    zipcode: false
                },
                LT: {
                    company_registration: true
                },
                LV: {
                    company_registration: true
                },
                MA: {
                    zipcode: false,
                    province: false
                },
                MK: {
                    city: true,
                    addressLine: true,
                    zipcode: true
                },
                MX: {
                    colony: true,
                    municipality: true
                },
                QA: {
                    city: false,
                    city_combo: true,
                    zipcode: false,
                    addressLine: true,
                    address_qatar: true
                },
                PH: {
                    city: false,
                    city_combo: true,
                    company_registration: false,
                    company: false,
                    province_dependant: true
                },
                //Serbia
                RS: {
                    city: true,
                    zipcode: true,
                    province_dependant: true,
                    company: false,
                    company_registration: false,
                    ident_document: true,
                    identdocument_value: true
                },
                SA: {
                    city: false,
                    city_combo: true
                },
                SG: {
                    company_registration: false
                },
                TH: {
                    company_registration: false,
                    city: false,
                    city_combo: true,
                    province_dependant: true
                },
                TN: {
                    city_combo: true,
                    city: false,
                    province_dependant: true,
                    company_registration: false
                },
                TR: {
                    nif: true,
                    city: false,
                    city_combo: true
                },
                TW: {
                    city: false,
                    city_combo: true,
                    company_registration: false,
                    lastname: false
                },
                UA: {
                    city: false,
                    city_combo: true,
                    province_dependant: true
                },
                MY: {
                    city: true,
                    addressLine: true,
                    province_dependant: true,
                    zipcode: true
                },
                VN: {
                    city: false,
                    city_combo: true,
                    province_dependant: true,
                    zipcode: false
                },
                XK: {
                    city: false,
                    city_combo: true,
                    province_dependant: true,
                }
            };

            if(countryFormAddressParameters[country] && 
                countryFormAddressParameters[country][parameter]!=undefined){
                return countryFormAddressParameters[country][parameter];
            } else {
                // special form fields are set to false(hide) by default
                if (
                    parameter === 'lastname_special' || 
                    parameter === 'province_dependant' ||
                    parameter === 'province_china' ||
                    parameter === 'city_combo' ||
                    parameter === 'digicode' ||
                    parameter === 'colony' ||
                    parameter === 'municipality' ||
                    parameter === 'nif' ||
                    parameter === 'personal_nif' ||
                    parameter === 'city_special' ||
                    parameter === 'address_qatar' ||
                    parameter === 'italy_company' ||
                    parameter === 'egypt_company' ||
                    parameter === 'bulgary_company' ||
                    parameter === 'company_registration' ||
                    parameter === 'ident_document' ||
                    parameter === 'identdocument_value' ||
                    parameter === 'regimen_fiscal' ||
                    parameter === 'taxcode_id' ||
                    parameter === 'zipcode_indonesia' ||
                    parameter === 'province_indonesia' ||
                    parameter === 'district_nocombo' ||
                    parameter === 'ifsccode'
                ) {
                    return false;
                } else {
                // common form fields are set to true(show) by default
                    return true;
                }
            }
        }

        /**
        * @ngdoc method
        * @name checkWalletAddress
        * @methodOf common.address.service:AddressService 
        * @description
        * Check if its necessary to clone address.
        */
        function checkWalletAddress(addressId){
            var deferred = $q.defer();

            // Obtengo el objeto address asociado al wallet 
            getAddressInfo(addressId)
            .then(function(walletAddress){
              if(walletAddress.addressType == 'SB') {
                var promises = [];
                // Me traigo todas las addresses del usuario que puede que el address del wallet no este.
                getUserAddresses()
                .then(function(addresses){
                    var addressCloned = billingAddressHasBeenCloned(addresses);
                    var newWalletAddress;
                    // Si el address no fue clonada y esta como wallet, la tengo que clonar.
                    if(addressCloned) {
                        newWalletAddress = addressCloned;
                    } else {
                        newWalletAddress = cloneAddress(walletAddress);
                    }
                    
                    newWalletAddress.preferred= true;

                    addOrUpdateAddress(newWalletAddress)
                    .then(function(addressId){
                        
                        deferred.resolve(true);
                    })
                    .catch(function(err){
                        
                        deferred.reject();
                    });

                    // return $q.all(promises)
                    // .then(function(data) {
                    //     if(data.length>0) {
                    //         deferred.resolve(data[0]);
                    //     } else {
                    //         deferred.resolve();
                    //     }
                    // });
                });

              } else {
                deferred.resolve(false);
              }
            })
            .catch(function(){
                deferred.reject();
            });
            
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name addOrUpdateAddress
         * @methodOf common.address.service:AddressService
         * @description
         * Creates an address or updates an existing one. If the address ID is included in the 'addressData' parameter, the
         * address with that ID will be updated with the new data sent. Otherwise, a new address will be created.
         * @param {Object} addressData - An Address object containing the address information.
         * @returns {number} the address ID of the created or updated address.
         */
        function addOrUpdateAddress (addressData) {
            var deferred = $q.defer();

            var action = {
                action: 'user:addUpdateAddress',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: addressData
            };

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                if (addressData.id) {
                    joyr.rest.addressInfoCache[addressData.id] = undefined;
                }
                joyr.rest.addressBookCache = [];
                deferred.resolve(data[0].id);
            })
            .Catch(function(err){
                console.error("ERROR ADDORUPDATE -",err.errorKey);
                manageSaveAddressError(err,addressData);
                err.managed = true;
                deferred.reject(err);
            });

            return deferred.promise;
        };

        function fillHiddendFields(address){
           
            if(!address.stateCode){
                address.stateCode  =  address.countryCode+'NONE';
                address.stateName  =  address.countryCode+'NONE';
            }
            return address;
        }

        /**
        * @ngdoc method
        * @name save
        * @methodOf common.address.service:AddressService
        * @description
        * 
        */
       /*function saveOld (address, from, replaceBilling) {

            var fromDroppoint = (from && from == 'droppoint');
            var fromStore = (from && from == 'store');
            
            address =  fillHiddendFields(address);
    
            return getUserAddresses()
            .then(function(addresses){
               
                if(fromStore) {
                    address.addressName = 'pickup#'+ address.email;
                }                 
                else {
                    if(address && !address.addressType){
                        address.addressType = 'S';
                        address.isShippingAddress = true;
                    }
                }
                var promises;
                if(fromDroppoint) {
                    promises = getDroppointPromises(address);
                } else if (fromStore)  {
                    promises = getPickupStorePromises(address);
                }
                else {
                    promises =  (address.addressType == 'SB') ? 
                    getBillingAddressPromises(addresses, address) : 
                    getShippingAddressPromises(addresses, address, replaceBilling);
                }
                
                return $q.all(promises)
                .then(function(data) {
                    if( !data || data.length == 0 ) {
                        return null;
                    }
                    if(data.length == 1){
                        return data[0];
                    } else if ( data.length > 1 ) {
                        return (address.addressType === 'S')? data[1]: data[0];
                    }   
                });
                
            });
        }*/

        /**
         * Función para guardar direcciones
         */
        function save (address, from, replaceBilling) {

            var deferred = $q.defer();
            var fromDroppoint = (from && from == 'droppoint');
            var fromStore = (from && from == 'store');
            
            address =  fillHiddendFields(address);

            getUserAddresses()
            .then(function(addresses){
                if(fromStore) {
                    address.addressName = 'pickup#'+ address.email;
                }                 
                else {
                    if(address && !address.addressType){
                        address.addressType = 'S';
                        address.isShippingAddress = true;
                    }
                }

                if(fromDroppoint) {
                    getDroppointId(address, addresses)
                    .then(function(dropPointOutput){
                        deferred.resolve(dropPointOutput.addressId);
                    })
                    .catch(function(err){
                        deferred.reject(err);
                    })
                }
                else if(fromStore){
                    getPickUpStoreId(address)
                    .then(function(storeId){
                        deferred.resolve(storeId);
                    })
                    .catch(function(err){
                        deferred.reject(err);
                    })
                }
                else if(address.addressType == 'SB'){
                    getBillingAddressId(addresses, address)
                    .then(function(output){
                        if(!output || !output.billingId){ //No deberia de entrar nunca pero lo dejamos preparado
                            deferred.resolve(null);
                        }
                        else{
                            deferred.resolve(output.billingId);
                        }
                    })
                    .catch(function(err){
                        deferred.reject(err);
                    });
                }
                else{
                    getShippingAddressId(addresses, address, replaceBilling)
                    .then(function(output){
                        if(!output || !output.shippingId){
                            deferred.resolve(null);
                        }
                        else{
                            deferred.resolve(output.shippingId);
                        }
                    })
                    .catch(function(err){
                        deferred.reject(err);
                    });
                }
            })
            .catch(function(err){
                console.error("ERROR SAVE -",err.errorKey);
                deferred.reject(err);
            });

            return deferred.promise;
        }

        /*function getPickupStorePromises(address) {
            var arrayOfPromises = [];
            address.addressName = 'pickup#'+ address.email;
            address.zipCode = '';
            address.isFullAddress=true;
            arrayOfPromises.push(addOrUpdateAddress(address));
            return arrayOfPromises;
        }*/

        function getPickUpStoreId(address){
            address.addressName = 'pickup#'+ address.email;

            /* 
                Si es de Colombia, no debe borrarse el zipCode porque es necesario para completar los datos de envío.
                Además. se desconoce la implicacion de quitar el borrado del zipCode en el resto de los mercados.
            */                
                
            if (!getCountryInfo().itxStoreConfigAddressTO.isBillingAddressMandatory && getCountryFormParameters(inditex.iCountryCode, 'zipcode')) {
                address.zipCode = '';
            }

            address.isFullAddress = true;
            return addOrUpdateAddress(address);
        }

        /*function getDroppointPromises(address){
            var arrayOfPromises = [];

            var billingAddress;
            // I dont have address completed
            if(!address.id) {
                billingAddress = _.cloneDeep(address);
                billingAddress.addressType = 'SB';
                billingAddress.zipCode = '';
                billingAddress.addressLines[0] ='-';
                billingAddress.city = '';
                billingAddress.stateCode = '-';
                // Delete droppoint related information.
                delete billingAddress.dropPointName;
                delete billingAddress.droppoint;
                delete billingAddress.idDropPoint;
                delete billingAddress.droppointType;
                delete billingAddress.idDropPointInterno;
                delete billingAddress.isShippingAddress;
                delete billingAddress.dropType;
            }
            
            address.addressName = 'pickup#'+ address.email;
            arrayOfPromises.push(addOrUpdateAddress(address));
            if(billingAddress) {
                arrayOfPromises.push(addOrUpdateAddress(billingAddress));
            }
            
            return arrayOfPromises; 
        }*/

        function isBillingAddressCompleteForDroppoint(address){
            if (!address) {
                return false;
            }
            if (getCountryInfo().itxStoreConfigAddressTO.isBillingAddressMandatory) {
                if (
                    address.city &&
                    address.stateName &&
                    address.zipCode &&
                    address.addressLines &&
                    address.countryName &&
                    address.email !== '' &&
                    address.firstName !== '' &&
                    address.lastName !== '' &&
                    address.phones[0].subscriberNumber &&
                    address.phones[0].subscriberNumber.length > 1 &&
                    address.phones[0].prefixCode &&
                    address.phones[0].prefixCode.length > 1
                ) {
                    return true;
                }
            } else {
                if (address.email !== '' &&
                address.firstName !== ''  &&
                address.lastName !== ''  &&
                address.phones[0].subscriberNumber  && address.phones[0].subscriberNumber.length >1 &&
                address.phones[0].prefixCode && address.phones[0].prefixCode.length >1
                ){
                    return true;
                }
            }
            return false;

        }
        function getDroppointId(address,addresses ){
            var deferred = $q.defer();

           
            var output = {};
            var billingAddress = getBillingAddressFromAddresses(addresses);
        
            if(isBillingAddressCompleteForDroppoint(billingAddress)){
                //NOMES UPDATE DE DROPPOINT.
                address.addressName = 'pickup#'+ address.email;
                addOrUpdateAddress(address)
                .then(function(addressId){
                    output.addressId = addressId;
                    deferred.resolve(output);
                }).catch(function(err){
                    console.error("ERROR DROPPOINT ID - ERROR ON CREATING DROPPOINT ADDRESS WHEN WE ALREADY HAVE COMPLETE BILLING ADDRESS");
                    deferred.reject(err);
                });
            }
            else{
                if (billingAddress){
                    billingAddress.firstName = address.firstName;
                    billingAddress.lastName = address.lastName;
                    billingAddress.phones = _.cloneDeep(address.phones);
                    if (getCountryInfo().itxStoreConfigAddressTO.isBillingAddressMandatory) {
                        billingAddress.city = _this.pickupFormModel.city;
                        billingAddress.stateCode = _this.pickupFormModel.stateCode;
                        billingAddress.stateName = _this.pickupFormModel.stateName;
                        billingAddress.zipCode = _this.pickupFormModel.zipCode;
                        billingAddress.addressLines = _this.pickupFormModel.addressLines;
                    }
                }

                else{
                    billingAddress = _.cloneDeep(address);
                    billingAddress.addressType = 'SB';
                    billingAddress.zipCode = '';
                    billingAddress.addressLines[0] = '-';
                    if (billingAddress.addressLines[1]){
                        billingAddress.addressLines[1] = '-';
                    }
                    billingAddress.city = '';
                    billingAddress.stateCode = '-';
                    // Delete droppoint related information.
                    delete billingAddress.isShippingAddress;
                    delete billingAddress.dropPointName;
                    delete billingAddress.droppoint;
                    delete billingAddress.idDropPoint;
                    delete billingAddress.droppointType;
                    delete billingAddress.idDropPointInterno;
                    delete billingAddress.isShippingAddress;
                    delete billingAddress.dropType;
                }

                address.addressName = 'pickup#'+ address.email;
                addOrUpdateAddress(billingAddress)
                .then(function(billingId){
                   
                    addOrUpdateAddress(address)
                    .then(function(addressId){
                        output.addressId = addressId;
                        output.billingId = billingId;
                        deferred.resolve(output);
                    })
                    .catch(function(err){
                        console.error("ERROR DROPPOINT ID - ERROR ON UPDATING BILLING ADDRESS DROPPOINT - ",inditex.iUserJSON.isWalletUser);
                        deferred.reject(err);
                    });
                   
                })
                .catch(function(err){
                    console.error("ERROR DROPPOINT ID - ERROR ON UPDATING ADDRESS DROPPOINT - ",inditex.iUserJSON.isWalletUser);
                    deferred.reject(err);
                });

            }
            

           

           

            return deferred.promise;
        }

        /*function getBillingAddressPromises(addresses, inputBillingAddress) {
            var addressCloned = billingAddressHasBeenCloned(addresses);
            var arrayOfPromises = [];

            inputBillingAddress.isShippingAddress = null;
            delete inputBillingAddress.droppointName;
            delete inputBillingAddress.idDropPoint;
            inputBillingAddress.addressName = inputBillingAddress.email || inputBillingAddress.addressLines[0];

            if( inputBillingAddress.countryCode == inditex.iStoreJSON.countryCode) {
                    arrayOfPromises.push(addOrUpdateAddress(inputBillingAddress));

                    // if(!billingAddressHasBeenCloned && addressIsComplete(address)) {
                    if(!addressCloned) {
                        var clonedBillingAddress = cloneAddress(inputBillingAddress);
                        $timeout(function(){
                            arrayOfPromises.push(addOrUpdateAddress(clonedBillingAddress));
                        },300);
                    } 
                
            } else {
                if (addressCloned) {
                    arrayOfPromises.push(addOrUpdateAddress(inputBillingAddress));
                } else {
                    var billingAddress = getBillingAddressFromAddresses(addresses);

                    if (!billingAddress) {
                        arrayOfPromises.push(addOrUpdateAddress(inputBillingAddress));
                    } else {
                        if (billingAddress.countryCode == inditex.iStoreJSON.countryCode) {
                            var clonedBillingAddress = cloneAddress(inputBillingAddress);
                            arrayOfPromises.push(addOrUpdateAddress(clonedBillingAddress));
                        }
                        arrayOfPromises.push(addOrUpdateAddress(inputBillingAddress));
                    }
                }
            }

            return arrayOfPromises;
        }*/

        function getBillingAddressId(addresses, inputBillingAddress){
            var deferred = $q.defer();
            var output = {};

            var addressCloned = billingAddressHasBeenCloned(addresses);
            inputBillingAddress.isShippingAddress = null;
            delete inputBillingAddress.droppointName;
            delete inputBillingAddress.idDropPoint;
            inputBillingAddress.addressName = (inputBillingAddress.email || inputBillingAddress.addressLines[0]) + '|' + inditex.iStoreIdentifier;
            // inputBillingAddress.addressName = inputBillingAddress.email || inputBillingAddress.addressLines[0];

            if(inditex.iCountryCode === 'CN' && inputBillingAddress.stateName){
                inputBillingAddress.municipality = inputBillingAddress.stateName;
            }

            if (inditex.iCountryCode === 'MX' && inputBillingAddress.company) {
                if (inputBillingAddress.company.vatin) {
                    inputBillingAddress.vatin = null;
                    inputBillingAddress.taxCode = null;
                    inputBillingAddress.taxCodeCode = null;
                    inputBillingAddress.taxRegime = null;
                    inputBillingAddress.taxRegimeCode = null;
                }
            }

            if(inputBillingAddress.countryCode == inditex.iStoreJSON.countryCode) {
                addOrUpdateAddress(inputBillingAddress)
                .then(function(inputBillingId){
                    output.billingId = inputBillingId;
                    if(!addressCloned && addressAbleToClone(inputBillingAddress)) {
                        var newShippingAddressFromBilling = cloneAddress(inputBillingAddress);
                        addOrUpdateAddress(newShippingAddressFromBilling)
                        .then(function(newShippingId){
                            output.shippingId = newShippingId;
                            deferred.resolve(output);
                        })
                        .catch(function(err){
                            console.error("ERROR BILLINGADDRES ID - ERROR ON UPDATING CLONED BILLING WHEN INPUT COUNTRY = INDI COUNTRY - ",inditex.iUserJSON.isWalletUser);
                            deferred.reject(err);
                        });
                    }
                    else{
                        deferred.resolve(output);
                    }
                })
                .catch(function(err){
                    console.error("ERROR BILLINGADDRES ID - ERROR ON UPDATING INPUT BILLING WHEN INPUT COUNTRY = INDI COUNTRY - ",inditex.iUserJSON.isWalletUser);
                    deferred.reject(err);
                });
            }
            else{
                var billingAddress = getBillingAddressFromAddresses(addresses);
                if(addressCloned || !billingAddress || (billingAddress.countryCode != inditex.iStoreJSON.countryCode)) { 
                    /* El !billingAddress tiene sentido aquí?
                            2 dudas:
                                1. solo no tendremos billingAddress cuando seamos guest i estemos en el checkout, y en ese caso no se llama a esta función,
                                si no que se llama a getShippingAddressId y ahí se crea tanto la SB como la S.
                                
                                2. Si no tenemos billing address, debería ser como en el primer IF, y crear tanto la SB como la S no? Y no solo la SB como
                                hará ahora.
                    */
                    addOrUpdateAddress(inputBillingAddress)
                    .then(function(inputBillingId){
                        output.billingId = inputBillingId;
                        deferred.resolve(output);
                    })
                    .catch(function(err){
                        console.error("ERROR BILLINGADDRES ID - ERROR ON UPDATING INPUT BILLING WHEN ADDRESS CLONED - ",inditex.iUserJSON.isWalletUser);
                        deferred.reject(err);
                    });
                }
                else{
                    if (CountryService.isWWCountry() &&  addressAbleToClone(inputBillingAddress) ) { 
                        var clonedBillingAddress = cloneAddress(inputBillingAddress);
                        addOrUpdateAddress(clonedBillingAddress)
                        .then(function(clonedBillingId){
                            output.clonedBillingId = clonedBillingId;
                            addOrUpdateAddress(inputBillingAddress)
                            .then(function(inputBillingId){
                                output.inputBillingId = inputBillingId;
                                deferred.resolve(output);
                            })
                            .catch(function(err){
                                console.error("ERROR BILLINGADDRES ID - ERROR ON UPDATING INPUT BILLING WHEN NOT ADDRESS CLONED");
                                deferred.reject(err);
                            });
                        })
                        .catch(function(err){
                            console.error("ERROR BILLINGADDRES ID - ERROR ON UPDATING CLONED BILLING WHEN NOT ADDRESS CLONED");
                            deferred.reject(err);
                        });
                    } else {
                        addOrUpdateAddress(inputBillingAddress)
                        .then(function(inputBillingId){
                            output.inputBillingId = inputBillingId;
                            deferred.resolve(output);
                        }).catch(function(err){
                            console.error("ERROR BILLINGADDRES ID - ERROR ADDING INPUT BILLING WHEN NOT ADDRESS CLONED");
                            deferred.reject(err);
                        });
                    }
                }
            }

            return deferred.promise;
        }

        /*function getShippingAddressPromises(addresses, shippingAddress, replaceBilling) {
            var arrayOfPromises = [];
            var addressCloned = billingAddressHasBeenCloned(addresses);
            
            shippingAddress.addressName='billingAddress#';

            var billingAddress = getBillingAddressFromAddresses(addresses);
            
            if(!replaceBilling && (addressCloned || (billingAddress && billingAddress.countryCode != inditex.iStoreJSON.countryCode ))) {
                arrayOfPromises.push(addOrUpdateAddress(shippingAddress));
            }
            else {
                
                if(!billingAddress || replaceBilling) {
                    var newBillingAddress = _.clone(shippingAddress);
                    delete newBillingAddress.id;
                    newBillingAddress.addressType = 'SB';
                    newBillingAddress.isShippingAddress = null;
                    newBillingAddress.addressName = newBillingAddress.email || newBillingAddress.addressLines[0];
                    arrayOfPromises.push(addOrUpdateAddress(newBillingAddress));
                    arrayOfPromises.push(addOrUpdateAddress(shippingAddress));
                } else {
                    if(billingAddress.countryCode == inditex.iStoreJSON.countryCode || inditex.iCountryCode === 'WW' ) {
                    
                        if( addressAbleToClone(billingAddress)){
                            var clonedBillingAddress = cloneAddress(billingAddress);
                            clonedBillingAddress.addressName='billingAddress#';
                            arrayOfPromises.push(addOrUpdateAddress(clonedBillingAddress));
                            arrayOfPromises.push(addOrUpdateAddress(shippingAddress));
                        } else {
                            var newBillingAddress=_.merge(billingAddress,shippingAddress);
                            delete newBillingAddress.id; 
                            newBillingAddress.addressName =  (newBillingAddress.email || newBillingAddress.addressLines[0]) + '|' + inditex.iStoreIdentifier;
                            newBillingAddress.addressType = 'SB';
                            newBillingAddress.isShippingAddress =null;
                            arrayOfPromises.push(addOrUpdateAddress(newBillingAddress));

                            shippingAddress=_.merge(billingAddress,shippingAddress);
                            delete shippingAddress.id;
                            delete shippingAddress.invoice;
                            delete shippingAddress.phones[0].prefixCode;
                            shippingAddress.municipality= (shippingAddress.municipality == '-')? '': shippingAddress.municipality;
                            shippingAddress.colony= (shippingAddress.colony == '-')? '': shippingAddress.colony;
                            arrayOfPromises.push(addOrUpdateAddress(shippingAddress));
                        }
                    }
                }
            }
            return arrayOfPromises;
        }*/

        function isBillingAddressComplete(address){
            if(!address){
                return false;
            }

            if(
                address.firstName && address.firstName!=''  &&
                address.lastName && address.lastName!=='' &&
                address.gender &&
                address.countryCode && address.countryCode!='' &&
                address.phones && address.phones.length >= 1 &&
                address.phones[0].subscriberNumber  && address.phones[0].subscriberNumber.length >1 &&
                address.phones[0].prefixCode && address.phones[0].prefixCode.length >1 &&
                address.addressLines && address.addressLines.length >= 1 && address.addressLines[0]!='-' && 
                address.city && address.city!='-' && address.city!='' &&
                address.zipCode && address.zipCode!='-' && address.zipCode!='' &&
                address.stateCode && address.stateCode!='-' && address.stateCode!=''
            )
            {
                return true;
            }

            return false;
        }

        function getShippingAddressId(addresses, shippingAddress, replaceBilling) {
            var deferred = $q.defer();
            var output = {};

            var addressCloned = billingAddressHasBeenCloned(addresses);
            shippingAddress.addressName = 'billingAddress#';

            var billingAddress = getBillingAddressFromAddresses(addresses);

            var billingSameCountry = billingAddress && (billingAddress.countryCode === inditex.iStoreJSON.countryCode);
            var billingIsComplete = isBillingAddressComplete(billingAddress);

            if(inditex.iCountryCode === 'CN' && shippingAddress.stateName){
                billingAddress.municipality = shippingAddress.stateName;
                shippingAddress.municipality = shippingAddress.stateName;
            }
            
            if(!billingAddress || replaceBilling || !billingIsComplete){
                var newBillingAddress = _.cloneDeep(shippingAddress);
                delete newBillingAddress.id;
                newBillingAddress.addressType = 'SB';
                newBillingAddress.isShippingAddress = null;
                newBillingAddress.addressName = (newBillingAddress.email || newBillingAddress.addressLines[0]) + '|' + inditex.iStoreIdentifier;
                addOrUpdateAddress(newBillingAddress)
                .then(function(billingId){
                    output.billingId = billingId;
                    addOrUpdateAddress(shippingAddress)
                    .then(function(shippingId){
                        output.shippingId = shippingId;
                        deferred.resolve(output);
                    })
                    .catch(function(err){
                        console.error("ERROR GETTING SHIPPING ADDRESS - ON UPDATING SHIPPING ADDRESS WHEN THERE'S NO BILLING ADDRESS - ",inditex.iUserJSON.isWalletUser);
                        deferred.reject(err);
                    });
                })
                .catch(function(err){
                    console.error("ERROR GETTING SHIPPING ADDRESS - ON UPDATING NEW BILLING ADDRESS WHEN THERE'S NO BILLING ADDRESS - ",inditex.iUserJSON.isWalletUser);
                    deferred.reject(err);
                });
            }
            else if(!replaceBilling && (addressCloned || !billingSameCountry )) {
                addOrUpdateAddress(shippingAddress)
                .then(function(shippingId){
                    output.shippingId = shippingId;
                    deferred.resolve(output);
                })
                .catch(function(err){
                    console.error("ERROR GETTING SHIPPING ADDRESS - ON UPDATING SHIPPING ADDRESS WHEN CLONED - ",inditex.iUserJSON.isWalletUser);
                    deferred.reject(err);
                });
            }
            else if (billingSameCountry || CountryService.isWWCountry()) {
                // VERSIÓN MINIFICADA
               
                if(addressAbleToClone(billingAddress)){
                    var newShippingAddressFromBilling = cloneAddress(billingAddress);
                    newShippingAddressFromBilling.addressName = 'billingAddress#';

                    addOrUpdateAddress(newShippingAddressFromBilling)
                        .then(function(){
                            //Se crea la shipping clonada en base a la billing.
                            addOrUpdateAddress(shippingAddress)
                            .then(function(shippingId){
                                //output.billingId = billingAddress.id; //NO DEBERIA SER  NECESARIO...
                                output.shippingId = shippingId;
                                deferred.resolve(output);
                            })
                            .catch(function(err){
                                console.error("ERROR GETTING SHIPPING ADDRESS - ON UPDATING SHIPPING ADDRESS WHEN COUNTRY CODE OF BILLING MATCHES - ",inditex.iUserJSON.isWalletUser);
                                deferred.reject(err);
                            })
                        })
                        .catch(function(err){
                            console.error("ERROR GETTING SHIPPING ADDRESS - ON UPDATING BILLING ADDRESS WHEN COUNTRY CODE OF BILLING MATCHES - ",inditex.iUserJSON.isWalletUser);
                            deferred.reject(err);
                        });

                }
                else{
                    var billingAddresToSave;
                    billingAddresToSave = _.merge({},billingAddress,shippingAddress);
                    delete billingAddresToSave.id; 
                    billingAddresToSave.addressName = (billingAddresToSave.email || billingAddresToSave.addressLines[0]) + '|' + inditex.iStoreIdentifier;
                    billingAddresToSave.addressType = 'SB';
                    billingAddresToSave.isShippingAddress = null;
                
                    shippingAddress.email = billingAddress.email;
                    /*shippingAddress = _.merge({},billingAddress,shippingAddress);
                    delete shippingAddress.id;
                    delete shippingAddress.invoice;
                    delete shippingAddress.phones[0].prefixCode;
                    */
                    shippingAddress.municipality = (shippingAddress.municipality == '-') ? '' : shippingAddress.municipality;
                    shippingAddress.colony = (shippingAddress.colony == '-') ? '' : shippingAddress.colony;

                    addOrUpdateAddress(billingAddresToSave)
                        .then(function(billingId){
                            output.billingId = billingId;
                            addOrUpdateAddress(shippingAddress)
                            .then(function(shippingId){
                                output.shippingId = shippingId;
                                deferred.resolve(output);
                            })
                            .catch(function(err){
                                console.error("ERROR GETTING SHIPPING ADDRESS - ON UPDATING SHIPPING ADDRESS WHEN COUNTRY CODE OF BILLING MATCHES - ",inditex.iUserJSON.isWalletUser);
                                deferred.reject(err);
                            });
                        })
                        .catch(function(err){
                            console.error("ERROR GETTING SHIPPING ADDRESS - ON UPDATING BILLING ADDRESS WHEN COUNTRY CODE OF BILLING MATCHES - ",inditex.iUserJSON.isWalletUser);
                            deferred.reject(err);
                        });

                }
                
                
                /*if( addressAbleToClone(billingAddress)){
                    var clonedBillingAddress = cloneAddress(billingAddress);
                    clonedBillingAddress.addressName = 'billingAddress#';
                    addOrUpdateAddress(clonedBillingAddress)
                    .then(function(billingId){
                        output.billingId = billingId;
                        addOrUpdateAddress(shippingAddress)
                        .then(function(shippingId){
                            output.shippingId = shippingId;
                            deferred.resolve(output);
                        })
                        .catch(function(err){
                            deferred.reject(err);
                        });
                    })
                    .catch(function(err){
                        deferred.reject(err);
                    });
                }
                else {
                    var newBillingAddress = _.merge(billingAddress,shippingAddress);
                    delete newBillingAddress.id; 
                    newBillingAddress.addressName = (newBillingAddress.email || newBillingAddress.addressLines[0]) + '|' + inditex.iStoreIdentifier;
                    newBillingAddress.addressType = 'SB';
                    newBillingAddress.isShippingAddress = null;
                    addOrUpdateAddress(newBillingAddress)
                    .then(function(billingId){
                        output.billingId = billingId;
                        shippingAddress = _.merge(billingAddress,shippingAddress);
                        delete shippingAddress.id;
                        delete shippingAddress.invoice;
                        delete shippingAddress.phones[0].prefixCode;
                        shippingAddress.municipality = (shippingAddress.municipality == '-') ? '' : shippingAddress.municipality;
                        shippingAddress.colony = (shippingAddress.colony == '-') ? '' : shippingAddress.colony;
                        addOrUpdateAddress(shippingAddress)
                        .then(function(shippingId){
                            output.shippingId = shippingId;
                            deferred.resolve(output);
                        })
                        .catch(function(err){
                            deferred.reject(err);
                        });
                    })
                    .catch(function(err){
                        deferred.reject(err);
                    });
                }*/
            }
            else{ //Devolvemos el output como null.
                output = null;
                deferred.resolve(output);
            }

            return deferred.promise;
        }

        function addressAbleToClone(address){
            return address.addressLines && address.addressLines[0]!='-' && 
            address.zipCode !='-' && 
            address.zipCode!='' &&
            address.stateCode!='-' &&
            address.stateCode!='';
        }

        function billingAddressHasBeenCloned (addresses){
            return _.find(addresses, function(address){
                        return (address.addressType ==='S' && 
                            (_.includes(address.addressName,'pickup#') ||
                            _.includes(address.addressName,'billingAddress#') ))
            });
        }

        // function save (address, from) {

        //     var deferred = $q.defer();

        //     if(from) {
        //         address.addressName = 'pickup#'+ address.email;
        //     } else {
        //         if(address && !address.addressType){
        //             address.addressType = 'S';
        //             address.isShippingAddress = true;
        //         }
        //     }
        //     getUserAddresses()
        //     .then(function(addresses){

        //         checkAndCloneAddress(addresses,address )
        //         .then(function(addressHasBeenCloned){
                    
        //             if(!addressHasBeenCloned){

        //                 addOrUpdateAddress(address)
        //                 .then(function(addressId){
        //                     deferred.resolve(addressId);
        //                 })
        //                 .catch(function(error){
        //                     manageSaveAddressError(error,address);
        //                     deferred.reject(error);
        //                 })
        //             } else {
        //                 deferred.resolve();
        //             }

        //         });
        //     })
        //     .catch(function(){
        //         deferred.reject('Error');
        //     });

        //     return deferred.promise;
        // }

        /**
        * @ngdoc method
        * @name checkAndCloneAddress
        * @methodOf common.address.service:AddressService
        * @description
        * Check if its necessary to clone the billing address based in the following conditions:
        * - I have one billing address which has not be created from pickup and not cloned before.
        * - I dont have a billing address and the shipping method is not pickup.
        * @param {array} userAddresses Array of user addresses
        * @param {object} address Optional Address object
        */
        function checkAndCloneAddress(userAddresses,address){
            var deferred = $q.defer();

            var addressToClone;
            
            if(address && (_.includes(address.addressName,'pickup#') || address.addressLines[0] == '-')) {
                deferred.resolve(false);
                return deferred.promise;
            }

            if(userAddresses.length == 0 && address){
                addressToClone = address;
            } else {
                var billingAddressHasBeenCloned = _.find(userAddresses, function(address){
                    return (address.addressType ==='S' && 
                            (_.includes(address.addressName,'pickup#') ||
                            _.includes(address.addressName,'billingAddress#') ));
                });

                if(!billingAddressHasBeenCloned && address.addressType !='SB'){
                    addressToClone = getBillingAddressFromAddresses(userAddresses);
                }
            }

            if(addressToClone){
                var clonedAddress = cloneAddress(addressToClone);
                var billingAddress = clonedAddress[0];
                var shippingAddress = clonedAddress[1];
                
                var promises = [addOrUpdateAddress(billingAddress),addOrUpdateAddress(shippingAddress)];

                $q.all(promises)
                .then(function(){
                    deferred.resolve(true);
                })
                .catch(function(error){
                    deferred.reject(error);
                });
            } else {
                deferred.resolve(false);
            }

            return deferred.promise;
        }


        /**
        * @ngdoc method
        * @name getBillingAddressFromAddresses
        * @methodOf common.address.service:AddressService
        * @description
        * Returns the billing address from user's addresses.
        * @param {array} addresses array of user addresses.
        * @returns {object} billing addresss.
        */
        function getBillingAddressFromAddresses(addresses){
            return _.find(addresses, function(address){
                return address.addressType ==='SB';
            });
        }

        /**
        * @ngdoc method
        * @name cloneAddress
        * @private
        * @methodOf common.address.service:AddressService
        * @description
        * Given an input address to clone this method will generate an array of 2 items with the billing address (addressType SB and address name billingAddress)
        * and shipping address (addressType S and isShippingAddress true)
        * @param {object} inputAddress Address object to clone.
        * @returns {array} Array with 2 items: billing address and shipping address in that order.
        */
        function cloneAddress(inputAddress){
            // var billingAddress = _.clone(inputAddress);
            var shippingAddress = _.cloneDeep(inputAddress);
            // billingAddress.addressType ='SB';
            // billingAddress.isShippingAddress = null;
            // delete billingAddress.id;
            // delete billingAddress.droppointName;
            // delete billingAddress.idDropPoint;
            // billingAddress.addressName = billingAddress.email || billingAddress.addressLines[0];
            shippingAddress.addressType = 'S';
            shippingAddress.isShippingAddress = true;
            shippingAddress.addressName = 'billingAddress#';
            delete shippingAddress.id;
            delete shippingAddress.idDropPoint;

            return shippingAddress;
        }
        // function cloneAddress(inputAddress){
        //     var billingAddress = _.clone(inputAddress);
        //     var shippingAddress = _.clone(inputAddress);
        //     billingAddress.addressType ='SB';
        //     billingAddress.isShippingAddress = null;
        //     // delete billingAddress.id;
        //     delete billingAddress.droppointName;
        //     delete billingAddress.idDropPoint;
        //     billingAddress.addressName = billingAddress.email || billingAddress.addressLines[0];
        //     shippingAddress.addressType = 'S';
        //     shippingAddress.isShippingAddress = true;
        //     shippingAddress.addressName = 'billingAddress#';
        //     delete shippingAddress.id;
        //     delete shippingAddress.idDropPoint;

        //     return [billingAddress, shippingAddress];
        // }

        /**
        * @ngdoc method
        * @name manageSaveAddressError
        * @methodOf common.address.service:AddressService
        * @description
        * Handles the error on save address request.
        * @param {object} error Error object returned by the API
        * @param {object} address Optional address object
        */
        function manageSaveAddressError(error,address){
            var errorMessage = "";
            var extraParams = "";
            if (error.errorKey === '_ERR_INVALID_VERTEX_ADDRESS') {
                errorMessage = error.errorMessage;
                extraParams = inditex.text('errorDialog.invalid_direction.title');
            } else {
                if (error.errorKey === 'GENERIC_PROBLEM' || error.errorKey === '_APP_PERSON_ADDRESS_UPDATE') {
                    errorMessage = ItxTranslateSvc.translateCms('legacy.Message_ItxAddressView_address_error')
                } else {
                    errorMessage = error.message;
                    if ( address.countryCode == 'US' || address.countryCode == 'CA') {
                        if(error.errorMessage !== undefined && error.errorMessage){
                            errorMessage = error.errorMessage
                        }
                    } else {
                        errorMessage = error.errorMessage;
                    }
                }
            }
            ItxErrorMessagesFct.dialog(errorMessage, extraParams);
        }

        /**
         * @ngdoc method
         * @name getUserAddresses
         * @methodOf common.address.service:AddressService
         * @description
         * Get the address already saved by user in the cache.
         */
        function getUserAddresses(fromCache){
            var deferred = $q.defer();
            
            if (fromCache && _this.addressBookCache.length) {
                deferred.resolve(_this.addressBookCache);
            }
            else{
                var action = {
                    action: 'user:addressBook',
                    params: {
                        storeId: inditex.iStoreId,
                        languageId: inditex.iLangId,
                        t: Date.now()
                    }
                };
    
                joyr.rest.xRestExecute([action])
                .done(function (data) {
                  
                    var addresses = data[0].addresses;
                    if(addresses.length==0){
                  
                        deferred.resolve(addresses);
                    } else {
                        //FIXME:Extract this funcionality to a utility method
                        if (inditex.iCountryCode === 'KR') {
                            for (var i = 0; i < addresses.length; i++) {
                                addresses[i].addressLines[0] = (addresses[i].addressLines[0] !== '-' ? addresses[i].addressLines[0] : '');
                                addresses[i].firstName = (addresses[i].firstName !== '-' ? addresses[i].firstName : '');
                                addresses[i].lastName = (addresses[i].lastName !== '-' ? addresses[i].lastName : '');
                            }
                        }
                        deferred.resolve(addresses);
                        // checkAndCloneAddress(addresses)
                        // .then(function(addressHasBeenCloned){
                        //     if(!addressHasBeenCloned){
                        //         deferred.resolve(addresses);
                        //     } else {
                        //         // After clon the address, we need to get it again.
                        //         joyr.rest.xRestExecute([action])
                        //         .done(function (data) {
                        //             deferred.resolve(addresses);
                        //         });
                        //     }
                            
                        // });
                    }
                })
                .Catch(function(){
                    deferred.resolve({});
                });
            }

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name getBeneficiaryCode
         * @methodOf common.address.service:AddressService
         * @description
         * Get the beneficiary code.
         */

        function getBeneficiaryCode() {
            let deferred = $q.defer();
            let request = new XMLHttpRequest();
            const host = inditex.iProxyHostStandard;
            const storeId = inditex.iStoreId;
            const langId = inditex.iLangId;
            const appId = inditex.iAppId;
            const url = `https://${host}/itxrest/2/store/${storeId}/config/address?languageId=${langId}&appId=${appId}`;
            const defoultBenficiary = {
                itxStoreConfigAddressTO: {
                    documentTypes: [
                        {
                            label: ItxTranslateSvc.translateCms('orders.address.resident'),
                            type: '19'
                        },
                        {
                            label: ItxTranslateSvc.translateCms('orders.address.not_resident'),
                            type: '29'
                        }
                    ]
                }
            };
            request.open('GET', url, true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.onload = function () {
                if (request.status >= 200 && request.status < 400) {
                    deferred.resolve(JSON.parse(request.response));
                    return deferred.promise;
                } else {
                    deferred.resolve(defoultBenficiary);
                }
            };
            request.onerror = function () {
                deferred.resolve(defoultBenficiary);
            };
            request.send();
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name getAddressInfo
         * @methodOf common.address.service:AddressService
         * @description
         * Get an address by its ID.
         * @param {string} addressId - The ID of the address to get.
         * @param {bool} [forceCommerce=false] - If true, indicates that the address is a commerce address, not a wallet
         *  address.
         * @param {string} [guestToken] - This parameter must be included to get an address associated with an order
         *  purchased by a guest user, when the guest user is no longer on session. Requires 'orderId'.
         * @param {number} [orderId] - The ID of the order to which the address being requested is associated. Requires
         *  'guestToken'.
         */
        function getAddressInfo(addressId, forceCommerce, guestToken, orderId) {
            var deferred = $q.defer();

            var action = {
                action: 'user:addressInfoById',
                params: {
                    storeId: inditex.iStoreId,
                    addressId: addressId,
                    forceCommerce: forceCommerce ? '1' : undefined,
                    languageId: inditex.iLangId
                }
            };

            if (guestToken && orderId) {
                action.action = 'user:addressInfoByIdGuest';
                action.params.guestToken = guestToken;
                action.params.orderId = orderId;
            }

            joyr.rest.xRestExecute([action])
                .done(function(data) {
                    //FIXME:Extract this funcionality to a utility method
                    if (inditex.iCountryCode === 'KR' && data[0]) {
                        data[0].addressLines[0] = data[0].city + (data[0].addressLines[0] !== '-' ? data[0].addressLines[0] : '');
                    }
                    deferred.resolve(data[0]);
                })
                .Catch(function() {
                    deferred.reject();
                });

            return deferred.promise;

        }

        function getGeocoderSuggestion(addressModel) {
            
            var deferred = $q.defer();
            
            var address = addressModel.addressLines[0] + ',' + addressModel.zipCode + ' ' + addressModel.city + ' ' + addressModel.stateName;
            
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                address: address,
                region: inditex.iCountryCode,

            }, function(results) {
                if (results[0]) {
                    var proposedAddress = prepareAddress(results[0],inditex.iCountryCode);
                    deferred.resolve(proposedAddress);
                } else {
                    deferred.reject(null);
                }
            });
            
            return deferred.promise;
        }

        /**
         * 
         * @ngdoc method
         * @description
         * Returns true if google suggested address is not complete
         * @param {object} address 
         */
        function incompleteSuggestedAddress(address) {

            // Si el código postal devuelto por google no coincide con la expresion regular
            // que el código postal tiene en ese país, no mostraremos la sugerencia para evitar
            // que se produzca error si continuamos en el tunel

            if(address.postalCode){
                if(!_this.regexZipCode.test(address.postalCode)){
                    return true;
                }
            }
            
            if(address.address){
                if(address.address === undefined){
                    return true;
                }
            }

            if( address.postalCode === undefined ||
                address.city === undefined ||
                address.province === undefined) {
                    return true;
            }

        }

        function prepareAddress(place, countryCode) {
            var addressArray = [];
            
            for (var i = 0; i < place.address_components.length; i++) {
                var addressComponent = place.address_components[i];
                if (_componentIs(place.address_components[i], 'route')) {
                    addressArray['address'] = addressComponent.long_name;
                }
                if (_componentIs(addressComponent, 'street_number')) {
                    addressArray['number'] = addressComponent.long_name;
                }
                if (_componentIs(addressComponent, 'postal_code')) {
                    addressArray['postalCode'] = addressComponent.long_name;
                }
                if (_componentIs(addressComponent, 'country')) {
                    addressArray['country'] = addressComponent.long_name;
                }
                if (_componentIs(addressComponent, 'locality')) {
                    addressArray['city'] = addressComponent.long_name;
                }
                if (!addressArray['city'] && _componentIs(addressComponent, 'sublocality')) {
                    addressArray['city'] = addressComponent.long_name;
                }
                if (!addressArray['province'] && (_componentIs(addressComponent, 'administrative_area_level_2') || _componentIs(addressComponent, 'administrative_area_level_1'))) {
                    addressArray['province'] = addressComponent.long_name;
                }
                if (_componentIs(addressComponent, 'sublocality_level_1')) {
                    addressArray['municipality'] = addressComponent.long_name;
                }
                if (_componentIs(addressComponent, 'administrative_area_level_3')) {
                    addressArray['colony'] = addressComponent.long_name;
                }

                // Special cases
                if ((countryCode === 'GB' || countryCode === 'SI') && _componentIs(addressComponent, 'postal_town')) {
                    addressArray['city'] = addressComponent.long_name;
                }
                if ((countryCode === 'IE' || countryCode === 'CY' || countryCode === 'DE' || countryCode === 'EE' || countryCode === 'HR' ||
                        countryCode === 'MX' || countryCode === 'NL' || countryCode === 'PL' || countryCode === 'SE' || countryCode === 'US' ||
                        countryCode === 'NO' || countryCode === 'CA') &&
                    _componentIs(addressComponent, 'administrative_area_level_1')) {
                    addressArray['province'] = addressComponent.long_name;
                }
                if (countryCode === 'CN' && _componentIs(addressComponent, 'sublocality_level_1')) {
                    addressArray['colony'] = addressComponent.long_name;
                }
                if (countryCode === 'MC' && _componentIs(addressComponent, 'locality')) {
                    addressArray['province'] = addressComponent.long_name;
                }
                if (countryCode === 'SK' && _componentIs(addressComponent, 'sublocality_level_1')) {
                    addressArray['province'] = addressComponent.long_name;
                }
            }

            return addressArray;
        }

        function _componentIs(component, type) {
            for (var i = 0; i < component.types.length; i++) {
                if (component.types[i] === type) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Creates an empty address
         * @returns {Address}
         */
        function _createEmptyAddress () {
            var address = {
                addressName: '',
                firstName: '',
                lastName: '',
                isCompany: false,
                addressLines: [],
                city: '',
                company: null,
                stateCode: '',
                countryCode: inditex.iStoreJSON.countryCode,
                countryName: inditex.iStoreJSON.countryName,
                zipCode: '',
                gender: 'F',
                phones: [{
                    countryCode: inditex.iStoreJSON.details.phoneCountryCode,
                    subscriberNumber: ''
                }]
            };

            return address;
        }

        /**
        * @ngdoc method
        * @name getAddressSubtitle
        * @methodOf common.address.service:AddressService
        * @description
        * Return subtitle address
        * @param {object} address Address object
        */
        function getAddressSubtitle(address) {
            if(!address){
            return;
            }
            var clonedAddress = _.cloneDeep(address);
            
            clonedAddress.city = clonedAddress.city.replace(/#/g, ' ');
        
            clonedAddress.colony = clonedAddress.colony.replace(/#/g, ' ');

            if (inditex.iCountryCode === 'AE') {
                clonedAddress.zipCode = '';
            }
            
            if(inditex.iStoreId === DUTTI_CONS.country.QA) { 
               return getFormatAddressQatar(clonedAddress);
            }
            if (inditex.iStoreId === DUTTI_CONS.country.BH ||
                inditex.iStoreId === DUTTI_CONS.country.JO ||
                inditex.iStoreId === DUTTI_CONS.country.EG) { 
                    var city = clonedAddress.city.replace(/[0-9]/g, '').replace(' ', '').replace(/#/g, '');
                    return clonedAddress.addressLines[0] + ' - ' + clonedAddress.stateName + ', ' + city
            }
            
            if (clonedAddress.addressLines[0]) {
                return clonedAddress.addressLines[0] + '-' +
                    (clonedAddress.zipCode !== '-' ? clonedAddress.zipCode : '' ) 
                        + (inditex.iCountryCode === 'KR' ? '' : ' ' + clonedAddress.city) 
                        + (inditex.iCountryCode === 'AE' ? ' ' + clonedAddress.stateName : '');
            } else {
                return '';
            }
        }

        /**
        * @ngdoc method
        * @name getAddressTitle
        * @methodOf common.address.service:AddressService
        * @description
        * Return title address
        * @param {object} address Address object
        */
         function getAddressTitle(address) {
            if(!address){
            return;
            }

            if (inditex.iCountryCode === 'HK') {
                return address.firstName
            } 
            else{
                if (inditex.iStoreJSON.details.isMiddleName) {
                    return address.firstName + ' ' + address.middleName + ' ' + address.lastName;
                } else {
                    return address.firstName + ' ' + address.lastName;
                }
            }
            
        }


        /**
        * @ngdoc method
        * @name formatAddressQatar
        * @methodOf common.address.service:AddressService
        * @description
        * Specific address format for qatar country
        * @param {object} addressModel
        * @returns {string}
        */
       function getFormatAddressQatar(addressModel, hideAdditionalData, isBilling) {
            var addressAditional = addressModel.addressLines.length >= 2 ? 
                            ' ' + addressModel.addressLines[1]
                            : '';
            var city = addressModel.city.replace(/[0-9]/g, '').replace(' ', '').replace(/#/g, '');
            var colony = addressModel.colony.replace(/[0-9]/g, '').replace(' ', '').replace(/#/g, '');

            // Todos estos campos de Qatar son necesarios, por tanto ninguno de ellos podrá ser undefined 
            if(addressModel.unitNumber !== undefined) {
                return inditex.text('ItxQatar.unitNumber') + ': ' + addressModel.unitNumber + ', ' +
                    inditex.text('ItxQatar.zoneNumber') + ': ' + addressModel.zoneNumber + ', '  +
                    inditex.text('ItxQatar.streetNumber') + ': ' + addressModel.addressLines[0]  + ', ' +
                    inditex.text('ItxQatar.buildingNumber') + ': ' + addressModel.buildingNumber  + 
                    addressAditional + (hideAdditionalData ? '': ', ' + city + ' - ' + colony);
            } else {
                return undefined;
            }
        };

        /**
        * @ngdoc method
        * @name isRestrictedZipCode
        * @methodOf common.address.service:AddressService
        * @description
        * Validate zipcode in case of adding/modifying a shippingAddress in spain or canary islands
        * @param {string} zipCode zip code to validate
        * @returns {boolean} valid 
        */
        function isRestrictedZipCode (zipCode){
            if (inditex.iStoreJSON.details.zipcodeRestricted && 
                (inditex.iStoreJSON.countryCode === 'ES' || inditex.iStoreJSON.countryCode === 'IC')) {
              var regex = new RegExp(inditex.iStoreJSON.details.zipcodeRestricted);
              return regex.test(zipCode);
          }
        }
               

        function fillDroppointAddress(addressModel, droppointInfo, dpEnabled, droppointType, isGermany, postnummer){

            _this.pickupFormModel = _.cloneDeep(addressModel);;

            addressModel.idDropPointInterno = addressModel.droppoint.internalId;

            // if (iAmGuest) {
            //     addressModel.addressName = '';
            // } else {
            //     addressModel.addressName = addressModel.email ?
            //         addressModel.email + '|' + storeIdentifier : storeIdentifier;
            // }
            addressModel.dropPointName = addressModel.droppointName;


            delete addressModel.droppointName;

            if (dpEnabled) {
                addressModel.addressLines = [droppointInfo.street];
            } else {
                // ECOMDUTI-6319 - Línea original. Si es necesario, comentar el if y dejar sólo esta parte.
                if(isGermany){
                    addressModel.addressLines = [droppointInfo.id, postnummer];
                }
                else{
                    addressModel.addressLines = [droppointInfo.street, droppointInfo.id];
                }
                
            }
            addressModel.city = droppointInfo.city;
            addressModel.zipCode = droppointInfo.zipCode;
            addressModel.isShippingAddress = true;
            addressModel.dropType = droppointType;
            //new values...
            if (dpEnabled) {
                addressModel.idDropPoint = droppointInfo.id;
                if (postnummer) {
                    addressModel.idDropPointUser = postnummer;
                }
            }
            // if the droppoint has stateCode, use item
            if (droppointInfo.stateCode && droppointInfo.stateCode !== '') {
                addressModel.stateCode = droppointInfo.stateCode;
                delete addressModel.stateName;
            }

            //avoid modifying billing addresses with droppoint addresses
            if (addressModel.addressType === 'SB') {
                addressModel.addressType = 'S';
                delete addressModel.id;
            }

        }

        function getBillingAddress(){

            return getUserAddresses().then(function(addressBook){
                return _.find(addressBook, function(address){
                    return address.addressType ==='SB';
                });
            });
        }

        function getBillingAddressZipCode(storeId) {
            var deferred = $q.defer();

            var action = {
                action: 'oam:xconfiguracion',
                params: {
                    variable: 'ZIPCODE_REGEXP_VALIDATION',
                    languageId: inditex.iLangId,
                    storeId: storeId
                }
            }

            joyr.rest.xRestExecute([action])
                .done(function(data){
                    deferred.resolve(data[0].value);
                })
                .Catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function getBillingAddressIsDocumentMandatory(storeId) {
            var deferred = $q.defer();

            var action = {
                action: 'oam:xconfiguracion',
                params: {
                    variable: 'IS_DOCUMENT_MANDATORY_ENABLED',
                    languageId: inditex.iLangId,
                    storeId: storeId
                }
            }

            joyr.rest.xRestExecute([action])
                .done(function(data){
                    if (data[0]) {
                        deferred.resolve(data[0].value);
                    }
                })
                .Catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name verifyTaxFieldsBillingAddress
        * @methodOf common.address.service:AddressService
        * @description
        * Validate if all colombian fields have value in billing address
        * @returns {boolean} show or hide fileds
        */        
        function verifyTaxFieldsBillingAddress() {
            var deferred = $q.defer();

            getBillingAddress()
            .then(function (billingAddress) {
                // Validar si todos los campos poseen valor, devuelvo false (se ocultarán)
                if (billingAddress.taxRegimeCode &&
                    billingAddress.taxCodeCode &&
                    billingAddress.documentTypeCode) {
                    deferred.resolve(false);
                } else {
                    // Se deben mostrar los campos
                    deferred.resolve(true);
                }
            }).catch(function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function getConfigAddress() {
            var deferred = $q.defer();

            var action = {
                action: 'GET_CONFIG_ADDRESS',
                params: {
                    languageId: inditex.iLangId,
                    storeId: inditex.iStoreId
                }
            }
            
            joyr.rest.xRestExecute([action])
                .done(function(data){
                    deferred.resolve(data[0]);
                })
                .Catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;

        }

        function getCountryInfo() {
            return _this.countryConfigCache;
        }

    }

})();
